import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Save01 } from '../../../assets';
import { ConfirmationDialog } from './ConfirmationDialog';
import { useTheme } from '@mui/material';

export interface ModalProps {
  open: boolean;
  onConfirmUrl: string;
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
  leaveWarningTitle?: string;
  leaveWarningContent?: string;
}

const LeavePageWithoutSaveModal = (props: ModalProps) => {
  const theme = useTheme();

  const navigate = useNavigate();
  const { t } = useTranslation('common');

  const handleConfirm = () => {
    navigate(props.onConfirmUrl);
    props.onConfirm();
  };

  const handleCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    } else {
      props.onClose();
    }
  };

  return <ConfirmationDialog open={props.open}
    message={t('leavePageWithoutSaveModal.message')}
    onConfirm={handleConfirm}
    onCancel={handleCancel}
    icon={<Save01 color={theme.palette.warning[500]} />}
    title={t('leavePageWithoutSaveModal.title')}
    variant='primary'
    confirmButtonText={t('leavePageWithoutSaveModal.confirmButtonText')}
    cancelButtonText={t('leavePageWithoutSaveModal.cancelButtonText')} />;
};

export default LeavePageWithoutSaveModal;